<template><SimpleModuleDashboard :module-id="Modules.FORMULARIOS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'crudForms', reference: 'crudForms', route: 'FormsStaffCrudForms', tone: 'primary' },
  { id: 'detailForms', reference: 'detailForms', route: 'FormsStaffDetailForms', tone: 'primary' },
] }) }
</script>
